import React, { useRef } from "react";
import * as Styles from "./styles/CollapsableStyles";
import { BnbLabel } from "../../../../utils/labels";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";

type CollapsableProps = {
    headerTitle: string;
    headerDescription?: React.ReactNode;
    icon?: React.ReactNode;
    ctaLabel: React.ReactNode;
    isPersonalized?: boolean;
    content: React.ReactNode;
    active: boolean;
    onChange: (isExpanded: boolean) => void;
    onTrack: () => void;
};

const Collapsable = (props: CollapsableProps): JSX.Element => {
    const { headerTitle, headerDescription, content, ctaLabel, isPersonalized, icon, onChange, onTrack, active } =
        props;
    const ref = useRef<HTMLDetailsElement | null>(null);
    const hasIcon = !!icon;

    const onToggle = (detailsElement?: HTMLDetailsElement): void => {
        if (!detailsElement || !ref.current) return;
        onChange(detailsElement ? detailsElement.open : ref.current.open);
    };

    const onClick = (): void => {
        if (ref.current) {
            ref.current.open = !ref.current.open;
        }
    };

    return (
        <Styles.Wrapper open={active} onToggle={($event) => onToggle($event.target as HTMLDetailsElement)} ref={ref}>
            {/* Only tracks clicks on the buttons for tracking purposes as the active state is determined externally */}
            <Styles.Header onClick={onTrack}>
                <Styles.HeaderContent>
                    {hasIcon && <IconWrapper>{icon}</IconWrapper>}
                    <div>
                        <Styles.HeaderTitle>{headerTitle}</Styles.HeaderTitle>
                        <Styles.HeaderDescription>{headerDescription}</Styles.HeaderDescription>
                    </div>
                </Styles.HeaderContent>

                <Styles.Button type="button" isActive={active || isPersonalized} onClick={onClick}>
                    <Styles.ButtonText>{active ? <BnbLabel label="close" /> : ctaLabel}</Styles.ButtonText>
                    <IconWrapper>
                        <Icon variant={active ? "close" : "plus"} />
                    </IconWrapper>
                </Styles.Button>
            </Styles.Header>
            <Styles.Content>{content}</Styles.Content>
        </Styles.Wrapper>
    );
};

export default Collapsable;
